// Page scroll lock for the <Modal> shell (farm phone/tablet spec W-12, audit
// X-13 / NW-07 / MA-13).
//
// A <Modal> is `position: fixed` over the page. On a page that scrolls the
// WINDOW (Fuel, Fertilising, Water, Drain, Analyses, the packhouse Stock
// register), a thumb dragged on the dim backdrop, or flicked past the end of
// the sheet's own body, scrolled the page behind it: a 200px drag moved Fuel
// from 600 to 175, a mouse wheel moved Fertilising 400px. The person closed
// the sheet somewhere else in the list.
//
// `overflow: hidden` on <html> stops that. It is REF-COUNTED because modals
// stack (Help → Report a bug; a picker's confirm over a form): the inner one
// closing must not unlock the page while the outer one is still open. Each
// release is idempotent, so a double cleanup cannot drive the count negative
// and unlock early.
//
// Programmatic scrolling still works under `overflow: hidden`, and the scroll
// position is kept, so the page is exactly where it was when the last modal
// closes. Where the page had a classic (space-taking) scrollbar, the gutter is
// kept (`scrollbar-gutter: stable`) so hiding it does not shift the page
// sideways behind the dialog.

let locks = 0
let restore: (() => void) | null = null

/** Lock the page's scroll until the returned release is called. */
export function lockPageScroll(): () => void {
  if (locks++ === 0) {
    const root = document.documentElement
    const prev = { overflow: root.style.overflow, gutter: root.style.getPropertyValue('scrollbar-gutter') }
    const hadScrollbar = window.innerWidth > root.clientWidth
    root.style.overflow = 'hidden'
    if (hadScrollbar) root.style.setProperty('scrollbar-gutter', 'stable')
    restore = () => {
      root.style.overflow = prev.overflow
      if (prev.gutter) root.style.setProperty('scrollbar-gutter', prev.gutter)
      else root.style.removeProperty('scrollbar-gutter')
    }
  }
  let released = false
  return () => {
    if (released) return
    released = true
    if (--locks === 0) {
      restore?.()
      restore = null
    }
  }
}
